import { AppRoutes, AppRoutesList, landDetailLink } from "./app.routes";

const MainMenuRoutes = [
  AppRoutes.Explore,
  // AppRoutes.EcoBank,
  AppRoutes.Help,
];

export { AppRoutes, AppRoutesList, MainMenuRoutes, landDetailLink };
